import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

export function useDeletePrivateNote() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await apiClient
        .from('private_notes')
        .delete()
        .eq('id', id);

      if (error) {
        throw error;
      }
    },
    onSuccess: () => {
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: keys.list(currentSpace.id) });
      }
    },
  });
}
